import { Component, Inject, forwardRef } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/core/core.module';
import { smoothlyMenu } from '../../app.helpers';
declare var jQuery: any;

@Component({
    selector: 'topnavbar',
    templateUrl: 'topnavbar.template.html',
    standalone: false
})
export class TopNavbarComponent {
        constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent, public auth: AuthenticationService, ) {}

    toggleNavigation(): void {
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }
}
